import { api } from "./api";
import Swal from "sweetalert2";

export const solicitarPrestamo = async (cif, idLibro, idRole, idCarreraCurso) => {
  const { data } = await api.post("/prestamos/solicitar", null, {
    params: { cif, idLibro, idRole, idCarreraCurso },
  });
  return data;
};

export const comprobarElegibilidad = async (cif, idLibro) => {
  const { data } = await api.post("/prestamos/comprobarElegibilidad", null, {
    params: { cif, idLibro },
  });
  return data;
};

export const verificarPrestamo = async (cif, idLibro) => {
  const { data } = await api.get("/prestamos/yaPrestado", {
    params: { cif, idLibro },
  });
  return data;
};


export const obtenerPrestamosPorEstudiantePaginados = async (cif, page = 0, size = 10) => {
  try {
    const { data } = await api.get("/prestamos/prestamosPorEstudiantePaginados", {
      params: { cif, page, size },
    });
    return data;
  } catch (error) {
    Swal.fire({ title: "Error al obtener tus préstamos:", text: String(error) });
    throw error;
  }
};

export const renovarPrestamo = async (cif, idPrestamo) => {
  const { data } = await api.post("/prestamos/renovarPrestamo", null, {
    params: { cif, idPrestamo },
  });
  return data;
};

export const obtenerPrestamoPorCodigoRetiro = async (codigoRetiro) => {
  const { data } = await api.get("/prestamos/buscarPorCodigoRetiro", {
    params: { codigoRetiro },
  });
  return data;
};

export const entregarLibro = async (idPrestamo, idPersonalEntrega, idCopia) => {
  const { data } = await api.put(`/prestamos/entregar/${idPrestamo}`, null, {
    params: { idPersonalEntrega, idCopia },
  });
  return data;
};

export const recibirLibro = async (idPrestamo, idPersonalRecepcion) => {
  const { data } = await api.put(`/prestamos/recibir/${idPrestamo}`, null, {
    params: { idPersonalRecepcion },
  });
  return data;
};

export const obtenerTodosLosPrestamos = async () => {
  const { data } = await api.get("/prestamos/todos");
  return data;
};

export const obtenerTodosLosPrestamosPaginados = async (page = 0, size) => {
  const { data } = await api.get("/prestamos/todosPaginados", {
    params: { page, size },
  });
  return data;
};
